require("normalize.css/normalize.css");
require("./styles/index.scss");

import Mouse from "./utils/mouse";
import Easing from "./utils/easing";
import SimpleNoise1D from "./utils/simpleNoise1D";
import Simplex from "./utils/simplexNoise.JS";

// const noise = new SimpleNoise1D();
const noise = new Simplex();

const canvas = document.querySelector(".main-canvas");
canvas.width = window.innerWidth * window.devicePixelRatio;
canvas.height = window.innerHeight * window.devicePixelRatio;
const ctx = canvas.getContext("2d");

const canvasWidth = canvas.width;
const canvasHeight = canvas.height;
let mouseX, mouseY;

window.addEventListener("mousemove", () => {
  mouseX = ((Mouse.cursor[0] + 1) / 2) * canvas.width;
  mouseY = ((Mouse.cursor[1] + 1) / 2) * canvas.height;
});

// ctx.fillStyle = "black";
// ctx.fillRect(0, 0, canvas.width / 2, canvas.height / 2);

// ctx.beginPath();
// ctx.fillStyle = "white";
// ctx.rect(75, 75, canvasWidth / 2, canvasHeight / 2);
// ctx.fill();
// ctx.closePath();

// ctx.beginPath();
// ctx.fillStyle = "green";
// ctx.arc(150, 150, 75, 0, Math.PI * 2, true);
// ctx.fill();
// ctx.closePath();

// ctx.beginPath();
// ctx.strokeStyle = "#00aa00";
// ctx.moveTo(-50, +50);
// ctx.lineTo(0, -50);
// ctx.lineTo(+50, +50);
// ctx.lineTo(-50, +50);
// ctx.stroke();
// ctx.closePath();

// for (let index = 0; index < 1000; index++) {
//   ctx.beginPath();
//   ctx.strokeStyle = `rgb(${Math.random() * 255}, ${Math.random() * 255}, ${
//     Math.random() * 255
//   })`;
//   ctx.moveTo(canvasWidth * Math.random(), canvasHeight * Math.random());
//   ctx.lineTo(canvasWidth * Math.random(), canvasHeight * Math.random());
//   ctx.stroke();
//   ctx.closePath();
// }

// let i = 0;
// setInterval(() => {
//   console.log(i);
//   ctx.beginPath();
//   ctx.strokeStyle = `rgb(${Math.random() * 255}, ${Math.random() * 255}, ${
//     Math.random() * 255
//   })`;
//   ctx.moveTo(canvasWidth * Math.random(), canvasHeight * Math.random());
//   ctx.lineTo(canvasWidth * Math.random(), canvasHeight * Math.random());
//   ctx.stroke();
//   ctx.closePath();
//   i++;
// }, 10);
// ctx.lineTo(canvasWidth / 2 + 500, canvasHeight / 2 + 500);
// ctx.lineTo(canvasWidth / 2 - 500, canvasHeight / 2 + 500);

// let image = new Image();
// image.onload = () => {};
// image.src =
//   "https://images.pexels.com/photos/10012067/pexels-photo-10012067.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260";
// ctx.drawImage(image, 0, 0);

let radius = 5;
let counter = 0;
let colorChanged = 0;
// à chaque image : 60fps

const drawCircle = (x, y, radius, color) => {
  ctx.beginPath();
  ctx.fillStyle = color;
  ctx.arc(Math.cos(x) * radius, Math.sin(y) * radius, 2, 0, Math.PI * 2);
  ctx.fill();
  ctx.closePath();
};

class Point {
  constructor(x, y, size = 50) {
    this.x = x;
    this.y = y;
    // this.size = size + 5 * Math.random();
    this.size = size;
    this.direction = Math.random() * Math.PI * 2;
    this.lifespan = 3 * Math.random();
    this.originalLifespan = this.lifespan;
    this.progresss = 1;
  }

  update() {
    this.x += Math.sin(this.direction);
    this.y += Math.cos(this.direction) + 1;
    // this.size = this.size + Math.abs(Math.sin(counter) * 50) * 0.001;

    this.progresss = this.lifespan / this.originalLifespan;
    this.lifespan -= 0.01;
  }

  draw() {
    // this.update();
    ctx.save();
    ctx.translate(this.x, this.y);
    ctx.beginPath();
    ctx.globalAlpha = this.progresss > 0 ? this.progresss : 0;
    ctx.fillStyle = `#FFFFFF`;
    ctx.arc(0, 0, this.size, 0, Math.PI * 2, true);
    ctx.fill();
    ctx.globalAlpha = 1;
    ctx.closePath();
    ctx.restore();
  }
}
let points = [];

const addPointer = (x, y) => {
  // Formula angle between two points
  // angle =  Math.atan2(p2.y - p1.y, p2.x - p1.x)
  let angle = Math.atan2(mouseY - canvas.height / 2, mouseX - canvas.width / 2);
  let size = 100;

  ctx.save();
  ctx.translate(x, y);
  ctx.rotate(angle);

  ctx.beginPath();
  ctx.moveTo(-size / 2, 0);
  ctx.lineTo(size / 2, 0);
  ctx.closePath();

  ctx.strokeStyle = "#FFFF";
  ctx.stroke();
  ctx.restore();
};

const cols = 100;
const steps = 50;
let frequency = 0.01;
let scale = 60;

const colorsArray = [
  `rgba(${255 * Math.random()}, ${255 * Math.random()}, ${
    255 * Math.random()
  }, 1)`,
  `rgba(${255 * Math.random()}, ${255 * Math.random()}, ${
    255 * Math.random()
  }, 1)`,
  `rgba(${255 * Math.random()}, ${255 * Math.random()}, ${
    255 * Math.random()
  }, 1)`,
  `rgba(${255 * Math.random()}, ${255 * Math.random()}, ${
    255 * Math.random()
  }, 1)`,
];

const addLines = (startX, startY, endY, color) => {
  const rand = Math.random();
  for (let i = 1; i <= cols; i++) {
    let endYProgress = startY;
    let endXProgress = startX;

    ctx.save();

    ctx.beginPath();
    ctx.strokeStyle = color;

    const x = (canvasWidth / cols) * i;

    for (let j = 0; j <= steps; j++) {
      ctx.moveTo(
        endXProgress,
        // noise.noise2D(endYProgress * frequency + counter * 2, counter) * scale
        endYProgress +
          noise.noise2D(endYProgress * frequency + counter, counter) * scale
      );
      endXProgress = startX != 0 ? startX - (x / steps) * j : (x / steps) * j;
      endYProgress =
        startY != 0 ? startY - (startY / steps) * j : (endY / steps) * j;
      // if (j == steps && i == 1) console.log(startY - (steps / startY) * j);
      ctx.lineTo(
        endXProgress,
        // noise.noise2D(endYProgress * frequency + counter * 2, counter) * scale
        endYProgress +
          noise.noise2D(endYProgress * frequency + counter, counter) * scale
      );
      ctx.stroke();
    }

    ctx.closePath();
    ctx.restore();
  }
};

const patterns = [0.666, 0.25, 4];
const pattern = patterns[Math.floor(Math.random() * 3)];

const update = () => {
  // ctx.fillStyle = `rgba(0, 0, 0, 0)`;
  // ctx.fillRect(0, 0, canvasWidth, canvasHeight);
  // ctx.clearRect(0, 0, canvasWidth, canvasHeight);
  // const point1 = new Point(canvasWidth / 2, canvasHeight / 2, 20);
  // const point2 = new Point(canvasWidth / 2, canvasHeight / 2, 30);

  // point1.x = mouseX;
  // point1.draw();

  // point2.targetX = mouseX;

  // let diffX = point2.targetX - point2.x;

  // diffX *= 0.05;
  // point2.x = diffX;

  // point2.draw();

  /* --------  LINE NOISE -------- */
  // ctx.fillStyle = `rgba(0, 0, 0, 0.05)`;
  // ctx.fillRect(0, 0, canvasWidth, canvasHeight);
  // // ctx.clearRect(0, 0, canvasWidth, canvasHeight);

  // let steps = 700;
  // let scale = 700;
  // let frequency = 5;

  // // let n = 0;
  // // frequency = Math.sin(counter * 0.05) / 2 + 0.5;

  // ctx.save();
  // ctx.translate(canvasWidth / 2, canvasHeight / 2);
  // for (let i = 0; i < 9; i++) {
  //   ctx.beginPath();
  //   ctx.strokeStyle = "white";

  //   n = noise.noise3D(counter, counter + i * 10) * scale;
  //   ctx.moveTo(Math.cos(0) * scale + n, Math.sin(0) * (scale + n));
  //   for (let x = 0; x < steps; x++) {
  //     let progress = x / steps;
  //     let angle = 2 * Math.PI * progress;

  //     let n =
  //       noise.noise4D(
  //         counter,
  //         Math.cos(angle * frequency),
  //         Math.sin(angle * frequency),
  //         i * 0.2
  //       ) * 100;
  //     scale = 100 + i * 100;
  //     ctx.lineTo(Math.cos(angle) * (scale + n), Math.sin(angle) * (scale + n));
  //   }
  //   let n =
  //     noise.noise3D(counter, Math.cos(0 * frequency), Math.sin(0 * frequency)) *
  //     50;
  //   ctx.lineTo(Math.cos(0) * scale, Math.sin(0) * scale);
  //   n = noise.noise3D(counter, counter + i * 10) * scale;
  //   ctx.lineTo(Math.cos(0) * scale + n, Math.sin(0) * (scale + n));
  //   ctx.stroke();
  //   ctx.closePath();
  // }
  // ctx.restore();

  /* ---------------- */

  // addLines(0, 0, canvasHeight, colorsArray[0]); // TOP L1
  // addLines(0, canvasHeight, 0, colorsArray[1]); // TOP BOT
  // addLines(0, canvasHeight, 10, colorsArray[2]); // TOP RIGHT
  // addLines(canvasWidth, canvasHeight, 10, colorsArray[3]); // TOP RIGHT

  /* --------  ETINCElLES -------- */
  // ctx.fillStyle = `rgba(0, 0, 0, 0.1)`;
  // ctx.rect(0, 0, canvasWidth, canvasHeight);
  // ctx.fill();
  // points.push(new Point(mouseX, mouseY, 2));
  // points = points.filter((point) => point.progresss > 0);
  // points.forEach((point) => point.draw());
  /* ---------------- */

  // ctx.clearRect(0, 0, canvas.width, canvas.height);
  // ctx.save();
  // ctx.beginPath();
  // ctx.arc(mouseX, mouseY, 200, 0, Math.PI * 2);
  // ctx.clip();
  // ctx.drawImage(image, 0, 0, canvas.width, canvas.height);
  // ctx.restore();

  // ctx.clearRect(0, 0, canvasWidth, canvasHeight);
  // ctx.fillStyle = `rgba(${255 * Math.random()}, ${255 * Math.random()}, ${
  //   255 * Math.random()
  // }, 0.1)`;

  /* ---------------- */

  ctx.fillStyle = `rgba(0, 0, 0, 0.05)`;
  ctx.rect(0, 0, canvasWidth, canvasHeight);
  ctx.fill();

  ctx.fillStyle = "white";

  ctx.save();
  ctx.translate(canvasWidth / 2, canvasHeight / 2);
  let color = colorsArray[0];
  for (let index = 0; index < 6000; index++) {
    if (index % 2000 == 1999 && colorChanged <= 1) {
      color = `rgba(${255 * Math.random()}, ${255 * Math.random()}, ${
        255 * Math.random()
      }, 1)`;
      colorChanged++;
    }
    const newRadius =
      (radius + 50 * index) * (Math.sin(counter) * 0.001) * 2 + 500;
    const x = counter + 0.5 * index + Math.cos(index) * pattern;
    const y = counter + 0.5 * index + Math.sin(index) * pattern;
    // const x = counter + 0.5 * index;
    // const y = counter + 0.5 * index;
    drawCircle(x, y, newRadius, color);
  }
  console.log(counter);
  ctx.restore();
  /* ---------------- */
  // ctx.clearRect(0, 0, canvas.width, canvas.height);
  // let grid = 10;
  // for (let x = 0; x < grid; x++) {
  //   for (let y = 0; y < grid; y++) {
  //     addPointer(
  //       canvasWidth / 2 + (x / grid - 0.5) * 2,
  //       canvasWidth / 2 + (y / grid - 0.5) * 2
  //     );
  //   }
  // }

  /* ---------------- */

  counter += 0.015;
  requestAnimationFrame(update);
};
update();
